import axios from 'axios';
import * as config from '../app/config';
import { Cache } from 'aws-amplify';

class APIClient {
  make(){
    var env       = config.BACKEND_ENV;
    var base_path = '';

    switch(env){
        case "prod":
          base_path = config.BACKEND_BASE_PATH_PROD;
          break;
        case "dev":
          base_path = config.BACKEND_BASE_PATH_DEV;
          break;
        case "test":
          base_path = config.BACKEND_BASE_PATH_TEST;
          break;
        default:
          base_path = config.BACKEND_BASE_PATH_LOCAL;
          break;
    }

    axios.interceptors.request.use((config)=>{
      config.baseURL = base_path;

      const apiToken = Cache.getItem('apiToken');
      if (apiToken) {
        config.headers = {
          'api-token': apiToken
        }
      }
      
      return config;
  
    }, (error) => {
        return Promise.reject(error);
    });
  
    return axios;
  }
}

export default APIClient;
